// this file is generated by update_shopify_store_data.py at 2026-11-03 20:11:35.504490
var courses = [
    {
        "course_id": "123ED515-7E8B-F111-99B2-005056A7F5E9",
        "course_version": 2,
        "name": "AAENP - OB Emergencies Bundle",
        "course_type": 32,
        "author_information": "",
        "description": "Pregnancy-related emergencies are uncommon in the emergency department and unforgiving when missed. The OB Emergencies Bundle concentrates on three high-stakes scenarios where recognition and early management change outcomes, taught by experts in emergency care who have managed them firsthand. \r\n\r\n3 Courses Included",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BAF35780-CF89-F111-99B9-005056A7EBB6",
                "course_category_name": "AAENP - OB Emergencies - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71623ACF-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - OB Emergencies Bundle",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "92188200-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Recognizing and Management of Incarcerated Gravid Uterus in the ED: An Update for Treatment",
                "course_type": 1,
                "author_information": "Dr. Jill Ogg-Gress, DNP, APRN, FNP-c ENP-c",
                "description": "This presentation aims to recognize and manage patients with symptoms suggestive of incarcerated gravid uterus (IGU) who present to the emergency department. It will outline strategies for identifying patients with complaints consistent with IGU, describe complications/risks, provide diagnostic recommendations, and discuss recently published new treatment strategies with minimally invasive ultrasound techniques for management. Case studies will also be provided during the presentation.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe common patient complaints consistent with incarcerated gravid uterus</li>\r\n    <li>Identify complications, risks, and diagnostics for incarcerated gravid uterus</li>\r\n    <li>Discuss modalities for treatment of incarcerated gravid uterus including new treatment strategies</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                        "course_category_name": "Obstetric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "71623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7A1F6972-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - OB Emergencies - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A3767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "154F411A-E017-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Code Red: Managing OB Hemorrhage following Spontaneous Abortion in the ED",
                "course_type": 1,
                "author_information": "Amanda Hitt, DNP, ENP-C, FNP-C",
                "description": "This course will examine common causes of hemorrhage in pregnancy and current guidelines for treatment.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss current treatment guidelines for selected OB emergencies during first trimester. </li>\r\n    <li>Discuss current treatment guidelines for selected OB emergencies during the second trimester.</li>\r\n    <li>Verbalize pathophysiology of common causes of hemorrhage following spontaneous abortion.</li>\r\n    <li>Identify pharmacological treatments and surgical options for hemorrhage following spontaneous abortion in the first trimester.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7A1F6972-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - OB Emergencies - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "71623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                        "course_category_name": "Obstetric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A3767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "A97370AA-4617-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Don't Ask, Don't Tell! Pregnancy-Related Hypertensive Emergencies that are Easy to Miss",
                "course_type": 1,
                "author_information": "Toni Dobson, MSN, ARPN, FNP-C, ENP-C",
                "description": "In this interactive, case-based presentation, we will cover a variety of ED presentations of pregnancy-related HTN, including pregnant and postpartum examples and some that were near-misses. Cases will be linked to the 2024 ACOG guidelines published to help non-obstetric providers manage pregnancy-related emergencies. We will discuss how to diagnose gestational hypertension, Pre-eclampsia, and Pre-eclampsia with severe features. Then, we will decide together how to treat each patient and determine who gets admitted and who goes home.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Develop a method to consistently identify this at-risk population of women.\r\n    </li>\r\n    <li>Define mild and severe range blood pressure and identify what requires urgent management.\r\n    </li>\r\n    <li>Diagnose gestational hypertension, pre-eclampsia, and pre-eclampsia with severe features.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "71623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D93823AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Vascular Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A3767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - OB Emergencies Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7A1F6972-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - OB Emergencies - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                        "course_category_name": "Obstetric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "26EF2AA5-22FE-E611-A7FF-005056B16BE3",
                        "course_category_name": "Obstetric Disorders",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];